

export const modal = () => {

  const modal = document.querySelectorAll(".modal");
  const modalClose = document.querySelectorAll(".js-modal-close");
  const modalOpen = document.querySelectorAll(".js-modal-open");
  const footer = document.querySelector('.main-footer');
  const forms = document.querySelectorAll('.js-form');
  const authForm = document.querySelector('.js-auth');
  const showPassword = document.querySelectorAll('.js-show-password');
  var distance = 0;
  var backForm = '';

  if(showPassword){
    for (let btn of showPassword){
      btn.addEventListener('click',function(){
        btn.classList.toggle("modal__password-icon_visible");
        let input = btn.previousElementSibling;
        if ( input.type === 'password' ) {
          input.type = 'text';
        } else {
          input.type = 'password';
        }
      });
    }
  }
  

  function disable_scroll() {
    document.querySelector(".site-container").classList.add("dis-scroll");
    document.querySelector(".site-container").scrollTo({
      top: distance,
      left: 0,
    });
  }


  document.addEventListener("click", function(e){

    if(e.target && e.target.className.indexOf("js-modal-open") > -1) {
      if ( e.target.dataset.info && e.target.dataset.modal ) {
        let modal = document.querySelector('.modal[data-modal='+e.target.dataset.modal+']');
        let input = modal.querySelector("input[name=info]");
        if ( input ) {
          input.value = e.target.dataset.info;
        }
      }

      if ( document.querySelector(".modal_open") ) {
        backForm = document.querySelector(".modal_open").dataset.modal;
        document.querySelector(".modal_open").classList.remove("modal_open");
        //console.log(backForm);
      } else {
        distance = window.pageYOffset;
        backForm = '';
      }

      if ( e.target.dataset.modal == 'registration'   ||
           e.target.dataset.modal == 'authorization'  ||
           e.target.dataset.modal == 'reset' 
      ) {
        backForm = '';
      }

      for(var z = 0; z < modal.length; z++){
        if ( modal[z].dataset.modal == e.target.dataset.modal ) {
          footer?.classList.add("main-footer_modal");
          modal[z].classList.add("modal_open");
          disable_scroll();
        }
      }

    }
  
  });


  function modal_close() {
    document.querySelector(".modal_open").classList.remove("modal_open");
    if ( backForm != '' ) {
      document.querySelector('.modal[data-modal='+backForm+']').classList.add("modal_open");
      backForm = '';
    } else {
      document.querySelector(".site-container").classList.remove("dis-scroll");
      footer?.classList.remove("main-footer_modal");
      window.scrollTo({
        top: distance,
        left: 0,
      });
    }
  }


  if ( modalClose ){
    for(var i = 0 ; i < modalClose.length; i++){
      modalClose[i].addEventListener("click", function(){
        modal_close();
      });
    }
  }

  if ( modal ) {
    for (var i = 0; i < modal.length; i++) {
      modal[i].addEventListener("mousedown",function(event){
        if (this == event.target){
          modal_close();
        }
      });
    }
  
    document.addEventListener('keydown', function(e) {
      let keyCode = e.keyCode;
      if (keyCode === 27) {
        modal_close();
      }
    });
  }
  




  

  if (forms) {
    for ( let form of forms) {
      form.addEventListener('submit', e => {
        e.preventDefault();
        let formData = new FormData(form);
        let formSuccess = form.dataset.success;
        let formAction = form.getAttribute("action");
        fetch(formAction, {
            method: "POST",
            body: formData
        }).then(response => response.json()).then(response => {
            if (response.success) {
                form.reset();

                if ( document.querySelector('.modal_open') ) {
                  document.querySelector('.modal_open').classList.remove("modal_open");
                } else {
                  footer?.classList.add("main-footer_modal");
                  distance = window.pageYOffset;
                  disable_scroll();
                }
                
                if( formSuccess ) {
                  document.querySelector('.modal[data-modal='+formSuccess+']').classList.add("modal_open");
                }

            }
        });
      })
    }
  }




  if ( authForm ) {
    authForm.addEventListener('submit', e => {
      e.preventDefault();
      let formData = new FormData(authForm);
      //let formSuccess = authForm.dataset.success;
      let formLoading = authForm.closest(".modal").querySelector(".modal__loading");
      let formAction = authForm.getAttribute("action");
      //let formPassword = authForm.closest(".modal").querySelector("input[type=password]").value;
      let authFormInputs = authForm.closest(".modal").querySelectorAll("input");
      let authFormError = authForm.closest(".modal").querySelector(".modal__error");
  
      fetch(formAction, {
          method: "POST",
          body: formData
      }).then(response => response.json()).then(response => {
          if ( response.success) {
            authForm.reset();

            if ( document.querySelector('#authIframe') ) {
              document.querySelector('#authIframe').innerHTML += `
              <iframe src="${response.data.url}" frameborder="0" style="display: none;"></iframe>
              `;
            }
  
            for (let input of authFormInputs ) {
              input.classList.remove("modal__input_error");
            }
  
            authFormError.classList.remove("modal__error_show");
  
            formLoading.classList.add("modal__loading_show");
  
            setTimeout(() => {
              modal_close();
              formLoading.classList.remove("modal__loading_show");
            }, 5000);

            setTimeout(() => {
              window.location.reload();
            }, 500);
  
          } else if ( !response.success ) {
  
            for (let input of authFormInputs ) {
              input.classList.add("modal__input_error");
            }
  
            authFormError.classList.add("modal__error_show");
  
          }
      });
    })
  }
  



}